module.exports = "/_next/static/images/27bb36e800dd70ca2e8b5d70eaa74034-boy-looking-to-the-front-lg@1x.jpg";